import React, {useMemo} from 'react';
import {useMergeEventMasterTableData} from "../../logs/useTableData";
import {Button, Input, Tag} from "antd";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import TablePage from "../../../pages/tablePage/TablePage";
import {MergeEventMasterEntity} from "./MergeEventMasterEntity";
import {MergeEventMasterTableEntity} from "./MergeEventMasterTableEntity";
import {saveMergeEventMaster} from "./useMergeEventMaster";
import {useGameDataConfig, useSaveGameDataConfig} from "../../../pages/csv/useCSVList";
import {DATA_CONFIG_KEY} from "../../../shared/utils/enum";

const MergeEventTable = () => {
    const {data: mergeEventMasterTable, isLoading, error} = useMergeEventMasterTableData();
    const {data: dataConfig, isLoading: isDataConfigLoading, error: dataConfigError} = useGameDataConfig(DATA_CONFIG_KEY.MERGE_EVENT_MEMO);
    const {mutate: saveDataConfig} = useSaveGameDataConfig();
    console.log(mergeEventMasterTable);
    const saveDataConfigMemo = async (index, memo) => {
        const newDataConfig = {...dataConfig, [index]: memo};
        saveDataConfig({config: newDataConfig, key: DATA_CONFIG_KEY.MERGE_EVENT_MEMO});
    }

    const handleSave = async (record) => {
        const row = new MergeEventMasterEntity(record);
        if (row.isInvalidate()) return;
        await saveMergeEventMaster(row.toJson());
    }

    const columns = useMemo(() => [
        {
            title: '머지 이벤트 인덱스',
            dataIndex: 'index',
            key: 'index',
            sorter: (a, b) => a.index - b.index,
        },
        {
            title: '머지 이벤트 이름',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '오픈 레벨',
            dataIndex: 'openLevel',
            key: 'openLevel',
        },
        {
            title: '메모',
            key: 'memo',
            render: (_, row) => {
                return (<Input
                    key={`memo-${row.index}-${dataConfig?.[row.index] || ''}`}
                    type="text"
                    defaultValue={ dataConfig ? dataConfig[row.index] || '' : '' }
                    style={{ width: '100%' }}
                    onBlur={(e) => saveDataConfigMemo(row.index, e.target.value)}
                    onPressEnter={(e) => saveDataConfigMemo(row.index, e.target.value)}
                />);
            }
        },
        {
            title: '액션',
            render: (record) => (
                <Button onClick={() => handleSave(record)}>
                    {'추가하기'}
                </Button>
            )
        },
        {
            title: '최소 적용 버전',
            dataIndex: 'minVersion',
            key: 'minVersion',
            render: (_, {index}) => (
                <Tag>{mergeEventMasterTable.find(e => e.index ===index)?.openVersion || '테이블에 값을 넣어주세요.'}</Tag>
            )
        },
    ], [mergeEventMasterTable, dataConfig]);

    if (isLoading || isDataConfigLoading) return <IsLoading/>;
    if (error || dataConfigError) return <ErrorPage error={error}/>;

    const props = {
        columns,
        isLoading: isLoading,
        localData: mergeEventMasterTable || [],
        entityModel: MergeEventMasterTableEntity,
    }

    return (
        <TablePage
            {...props}
        />
    );
};

export default MergeEventTable;